import { Component, OnInit } from '@angular/core';
import { HttpSession } from 'src/app/libs/ruvpp-angular2-comun/HttpSession';
import { Router } from '@angular/router';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['../../../assets/css/styles.css'/*, '../../../assets/css/bootstrap.css'*/]
})
export class MenuComponent implements OnInit {

    public usuario: string;

    /**
     * 
     * @param _router
     */
    constructor(private _router: Router) { }

    ngOnInit(): void {
        this.usuario = HttpSession.getAttribute('USER_NAME');
    }

    /**
   *
   */
    public Login(): void {
        HttpSession.clear();
        this._router.navigate(['Login']);
    }

    /**
     * 
     */
    public Simulador(forward?: string): void {

        if (forward != null) {
            HttpSession.setAttribute('FORWARD', forward);
        }

        HttpSession.forward(this._router, 'Simulador');
    }

    /**
     * 
     */
    public CloseSesion(): void {
        HttpSession.clear();
        //HttpSession.forward(this._router, 'PortadaSimulador');
        HttpSession.forward(this._router, 'PortadaInicioComponent');
    }

    /**
     * 
     */
    public PortadaSimuladorAdmin() {
        HttpSession.forward(this._router, 'PortadaSimuladorAdmin');
    }

    /**
     * 
     */
    public CatalogoManoObra() {
        HttpSession.forward(this._router, 'CatalogoManoObra');
    }

    /**
     * 
     */
    public CatalogoMateriales() {
        HttpSession.forward(this._router, 'CatalogoMateriales');
    }

    /**
     * 
     */
    public CatalogoElementos() {
        HttpSession.forward(this._router, 'CatalogoElementos');
    }

    /**
     * 
     */
    public CatalogoEspacios() {
        HttpSession.forward(this._router, 'CatalogoEspacios');
    }

    /**
     * 
     */
    public CatalogoPrototipos() {
        HttpSession.forward(this._router, 'CatalogoPrototipos');
    }

    /**
     * 
     */
    public SimuladorPrototipos() {
        HttpSession.forward(this._router, 'SimuladorPrototipos');
    }
}
